<template>
    <div>
      <translator-payments-list></translator-payments-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>